import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {HcaMemberService} from '../../../../../../shared/_services/hca-member.service';
import {UtilService} from '../../../../../../shared/_services/util.service';

@Component({
  selector: 'app-members-hard-delete-audit-list',
  templateUrl: './members-hard-delete-audit-list.component.html',
  styleUrls: ['./members-hard-delete-audit-list.component.scss']
})
export class MembersHardDeleteAuditListComponent implements OnInit {
  auditList: any[] = [];
  totalCount = 0;
  p = 1;
  size = 20;
  loading = false;
  errorMessage = '';
  canViewAudit = false;
  filterForm: FormGroup;
  expandedId: number = null;
  detailLoading = false;
  detailCache: any = {};

  constructor(
    private hcaMemberService: HcaMemberService,
    public utilService: UtilService
  ) {}

  ngOnInit() {
    this.canViewAudit = this.hasAuditAccess();
    this.filterForm = new FormGroup({
      email: new FormControl(''),
      memberId: new FormControl(''),
      cardCode: new FormControl(''),
      from: new FormControl(''),
      to: new FormControl('')
    });
    if (this.canViewAudit) {
      this.loadAudits(0);
    }
  }

  hasAuditAccess(): boolean {
    const user = JSON.parse(localStorage.getItem('loggedInUser'));
    if (!user || !user.token) {
      return false;
    }
    const role = this.utilService.parseJwt(user.token).info.roles;
    return ['ROLE_HCA', 'ROLE_CCS'].indexOf(role) >= 0;
  }

  loadAudits(page: number) {
    this.loading = true;
    this.errorMessage = '';
    const filters = this.buildFilters();
    this.hcaMemberService.getHardDeleteAudit(page, this.size, filters).subscribe(res => {
      this.loading = false;
      if (res.error === 0 && res.responseObj) {
        this.auditList = res.responseObj.results || [];
        this.totalCount = res.responseObj.totalRecords || 0;
      } else {
        this.auditList = [];
        this.totalCount = 0;
        this.errorMessage = res && res.message ? res.message : 'Unable to load hard delete audits.';
      }
    }, () => {
      this.loading = false;
      this.auditList = [];
      this.totalCount = 0;
      this.errorMessage = 'Unable to load hard delete audits.';
    });
  }

  buildFilters() {
    const filters: any = {};
    const email = (this.filterForm.get('email').value || '').trim();
    const memberId = (this.filterForm.get('memberId').value || '').trim();
    const cardCode = (this.filterForm.get('cardCode').value || '').trim();
    const from = this.filterForm.get('from').value;
    const to = this.filterForm.get('to').value;
    if (email) {
      filters.email = email;
    }
    if (memberId) {
      filters.memberId = memberId;
    }
    if (cardCode) {
      filters.cardCode = cardCode;
    }
    if (from) {
      filters.from = from + 'T00:00:00Z';
    }
    if (to) {
      filters.to = to + 'T23:59:59Z';
    }
    return filters;
  }

  search() {
    this.p = 1;
    this.expandedId = null;
    this.loadAudits(0);
  }

  clearFilters() {
    this.filterForm.reset({email: '', memberId: '', cardCode: '', from: '', to: ''});
    this.search();
  }

  pageChanged(event: number) {
    this.p = event;
    this.expandedId = null;
    this.loadAudits(event - 1);
  }

  formatDate(value: string | number): string {
    if (value == null || value === '') {
      return '';
    }
    // OffsetDateTime can arrive as epoch seconds; moment expects ms or an ISO string.
    const parsed = typeof value === 'number' && value > 0 && value < 1e12
      ? value * 1000
      : value;
    return this.utilService.dateFormat(parsed, 'MMM DD, YYYY hh:mm:ss A');
  }

  getFullName(item: any): string {
    if (!item) {
      return '—';
    }
    const parts = [item.firstName, item.lastName1, item.lastName2].filter(part => !!part);
    return parts.length ? parts.join(' ') : '—';
  }

  toggleDetail(item: any) {
    if (!item || !item.id) {
      return;
    }
    if (this.expandedId === item.id) {
      this.expandedId = null;
      return;
    }
    this.expandedId = item.id;
    if (this.detailCache[item.id]) {
      return;
    }
    this.detailLoading = true;
    this.hcaMemberService.getHardDeleteAuditById(item.id).subscribe(res => {
      this.detailLoading = false;
      if (res.error === 0 && res.responseObj) {
        this.detailCache[item.id] = res.responseObj;
      } else {
        this.detailCache[item.id] = {error: res && res.message ? res.message : 'Unable to load audit detail.'};
      }
    }, err => {
      this.detailLoading = false;
      this.detailCache[item.id] = {
        error: err && err.message ? err.message : 'Unable to load audit detail.'
      };
    });
  }

  getDetail(id: number): any {
    return this.detailCache[id] || null;
  }

  getMapEntries(mapObj: any): any[] {
    if (!mapObj || typeof mapObj !== 'object') {
      return [];
    }
    return Object.keys(mapObj).map(key => {
      const value = mapObj[key];
      return {
        key: key,
        value: typeof value === 'object' ? JSON.stringify(value) : value
      };
    });
  }

  getSnapshotJson(detail: any): string {
    if (!detail || !detail.memberSnapshotJson) {
      return '';
    }
    try {
      return JSON.stringify(detail.memberSnapshotJson, null, 2);
    } catch (e) {
      return String(detail.memberSnapshotJson);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/members/members-management/members-hard-delete-audit-list/members-hard-delete-audit-list.component.ts